module.exports = __webpack_public_path__ + "static/img/dashboardScale.1876248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/dashboardScale.png
// module id = 8JYx
// module chunks = 2